import { AvonPatientEmbed } from 'react-components/member-profile/avonPatientEmbed';
import { Routes, SyncHook } from '../route-types';

export const MEMBER_LIST_PREFIX_PATH = '/member-list';

const useSyncHook: SyncHook = null;

const routes: Routes = [
  {
    path: '/avon-patient',
    element: <AvonPatientEmbed />,
  },
];

const useNavigationHooks = () => {
  return {};
};

export const avonPatientRouteConfig = {
  routes,
  useSyncHook,
  hideNavigationHeader: true,
  useNavigationHooks,
};
